module.exports = __webpack_public_path__ + "static/media/icon_ok_red_new.e90725be.svg";